import { DesktopDatePicker } from "@mui/x-date-pickers-pro";
import { Controller, useFormContext } from "react-hook-form";
import { FormKeys } from "../../helpers";

type Props = {
  isReadOnly: boolean;
};

const StartField = ({ isReadOnly }: Props) => {
  const {
    control,
    setValue,
    formState: { errors, defaultValues },
  } = useFormContext();

  return (
    <Controller
      name={FormKeys.WorkStarts}
      control={control}
      rules={{
        required: true,
      }}
      render={({ field, fieldState }) => (
        <DesktopDatePicker
          {...field}
          value={field.value}
          disabled={isReadOnly}
          onChange={(date) => {
            field.onChange(date);
            setValue(
              "supplementPriceOverrides",
              defaultValues?.supplementPriceOverrides,
            );
          }}
          slotProps={{
            textField: {
              size: "small",
              label: null,
              error: !!fieldState.error || !!errors[FormKeys.WorkStarts],
            },
          }}
        />
      )}
    />
  );
};

export const StartEndDates = ({ isReadOnly }: Props) => {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const { reasonForTemporaryEmployment } = watch();

  return (
    // If order type is fixedTerm, ask for date range. If it's is continuous, ask only for start date.
    !reasonForTemporaryEmployment ? (
      <StartField isReadOnly={isReadOnly} />
    ) : (
      <>
        <StartField isReadOnly={isReadOnly} />
        <Controller
          name={FormKeys.WorkEnds}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState }) => (
            <DesktopDatePicker
              {...field}
              value={field.value}
              disabled={isReadOnly}
              slotProps={{
                textField: {
                  size: "small",
                  label: null,
                  error: !!fieldState.error || !!errors[FormKeys.WorkEnds],
                },
              }}
            />
          )}
        />
      </>
    )
  );
};
